import type { ComputedRef, Ref } from 'vue'
import { createContext } from 'reka-ui'

export const SIDEBAR_WIDTH = '16rem'
export const SIDEBAR_WIDTH_MOBILE = '18rem'
export const SIDEBAR_WIDTH_ICON = '3rem'
export const SIDEBAR_KEYBOARD_SHORTCUT = 'b'

export const [useSidebar, provideSidebarContext] = createContext<{
  state: ComputedRef<'expanded' | 'collapsed'>
  open: Ref<boolean>
  setOpen: (value: boolean) => void
  isMobile: Ref<boolean>
  openMobile: Ref<boolean>
  setOpenMobile: (value: boolean) => void
  toggleSidebar: () => void
  /**
   * Live width (in px) of the desktop sidebar in expanded mode. Wired through
   * `--sidebar-width` on the wrapper so every consumer that already reads
   * that variable (gap div, fixed pane, offcanvas offsets) animates together.
   */
  width: Ref<number>
  setWidth: (value: number) => void
  /**
   * `true` while the user is dragging the rail. Consumers (e.g. `Sidebar`)
   * use this to suppress the default width transition so the rail tracks
   * the cursor instantly instead of trailing it.
   */
  isResizing: Ref<boolean>
  setResizing: (value: boolean) => void
}>('Sidebar')
